import { FC } from "react";

import { Box, useMultiStyleConfig } from "@chakra-ui/react";

import type { TNoOptionsMessageProps } from "./types";

const NoOptionsMessage: FC<TNoOptionsMessageProps> = ({ message }) => {
  const styles = useMultiStyleConfig("TimePicker", {});
  return <Box sx={styles.noOptionsMessage}>{message}</Box>;
};
export default NoOptionsMessage;
